import type { SVGProps } from 'react';

import mark from './mark.svg';
import wordmark from './wordmark.svg';

export const PRODUCT_NAME = 'CitizenShipper';

export const CitizenShipperMark = ({
  width = '1em',
  height = '1em',
  ...props
}: SVGProps<SVGSVGElement>) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 512 512"
    role="img"
    aria-label={PRODUCT_NAME}
    {...props}
  >
    <image href={mark} width="512" height="512" />
  </svg>
);

export const CitizenShipperWordmark = () => (
  <img
    src={wordmark}
    alt={PRODUCT_NAME}
    width={200}
    style={{ maxWidth: '100%', height: 'auto' }}
  />
);
